import { render, staticRenderFns } from "./doctype-sidesheet.vue?vue&type=template&id=2e2ba162&scoped=true&"
import script from "./doctype-sidesheet.vue?vue&type=script&lang=js&"
export * from "./doctype-sidesheet.vue?vue&type=script&lang=js&"
import style0 from "./doctype-sidesheet.vue?vue&type=style&index=0&id=2e2ba162&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e2ba162",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2e2ba162')) {
      api.createRecord('2e2ba162', component.options)
    } else {
      api.reload('2e2ba162', component.options)
    }
    module.hot.accept("./doctype-sidesheet.vue?vue&type=template&id=2e2ba162&scoped=true&", function () {
      api.rerender('2e2ba162', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/documents/doctype-sidesheet.vue"
export default component.exports